import React from 'react'

// components
import {
  CRow
} from '@coreui/react-pro'
import AppTextColumnDetails from '../general-details/AppTextColumnDetails'

const AppDetails = ({
  clientVoucherDetails,
}) => {
  return (
    <>
      <CRow className='mb-4'>
        <AppTextColumnDetails
          colSize="3"
          title="Client code"
          subtitle={clientVoucherDetails?.client_code ? clientVoucherDetails?.client_code : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Used?"
          subtitle={clientVoucherDetails?.is_used ? 'Yes' : 'No'}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Game pass?"
          subtitle={clientVoucherDetails?.is_game_pass ? 'Yes' : 'No'}
        />
      </CRow>
    </>
  )
}

export default AppDetails
